import styled from 'styled-components';
import { ViewShow as MaterialViewShow } from '../../../../../styles/icons';


export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ViewShow = styled(MaterialViewShow)`
  width: 25px;
  height: 25px;
  fill: var(--secondary);
`;
